import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import React, { useState, useRef, useEffect } from "react";
import LikeSvg from "../assets/images/like.svg";
import DislikeSvg from "../assets/images/dislike.svg";
import CommentSvg from "../assets/images/comment.svg";
import ForwardSvg from "../assets/images/forward.svg";
import MenuSvg from "../assets/images/menu.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-flip";

// import required modules
import { EffectCube, Autoplay } from "swiper";
import config from "../config";
import detectLanguage from "./promotedPreviewStyles";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";
const CubeAnimation = ({ images = [] }) => {
  const swiperRef = React.useRef(null);
  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.start(); // Restart autoplay when mounted
    }
    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy();
        swiperRef.current = null;
      }
    };
  }, []);
  return (
    <Swiper
      effect="cube"
      grabCursor={true}
      loop={true}
      loopAdditionalSlides={images.length} // Helps prevent restarting issue
      watchSlidesProgress={true} // Ensures smooth looping
      speed={600} // Adjust speed for smoother transition
      cubeEffect={{
        shadow: true,
        slideShadows: false, // Removing shadows for better smoothness
        shadowOffset: 20,
        shadowScale: 0.94,
      }}
      autoplay={{
        delay: 2000, // Adjust timing for a continuous feel
        disableOnInteraction: false,
      }}
      modules={[EffectCube, Autoplay]}
      className="mySwiper"
      onSwiper={(swiper) => (swiperRef.current = swiper)}
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <img
            key={image.img_id}
            src={image?.image}
            className=""
            alt={`cube ${index + 1}`}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

function NewsImageFlip({ preview }) {
  const { heading, descrip } = detectLanguage(
    preview.head_line || config.HEADLINE
  );
  return (
    <>

      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />

        <div className="preview-inner">
          <div className="preview-full-image">
            <div className="h-full">
              <div className="relative rounded-t-lg h-[40%] overflow-hidden news-image">
                <CubeAnimation
                  key={Date.now()}
                  images={[
                    preview.post_image ? { image: preview.post_image } :
                      { image: `https://d1uy1wopdv0whp.cloudfront.net/newsimages/news_32025/1741237146619_746-normal-WIFI.webp` },
                    ...(preview.gallery ? [...preview.gallery] : []),
                  ]}
                />
              </div>
              <div className="flex flex-col justify-between min-h-[60%]">
                <div className="px-2 mt-2">
                  <h5 style={heading}>
                    {preview.head_line || config.HEADLINE}
                  </h5>
                  <p style={descrip} className="text-base">
                    {preview.description || config.DESCRIPTION}
                  </p>
                </div>
                <div>
                  <div className="px-2 text-xs mb-3">
                    <div className="d-flex gap-1 items-center">
                      <SlIcon className="text-gray-400" name="clock-4" library="lucide" />
                      <span className="text-bold">7m ago</span>
                      <span className="text-gray-400">/ 2 of 196 Stories</span>
                    </div>
                    <div className="border-gray-200 my-2 px-0 py-0 border-b"></div>
                    <div className="d-flex justify-between items-center my-0 px-2 py-0">
                      <div className="d-flex gap-2 items-center my-1">
                        <div className="d-flex items-center gap-[2px]">
                          <img src={LikeSvg} alt="like"></img>
                          <span className="text-gray-400">720</span>
                        </div>
                        <div className="d-flex items-center gap-[2px]">
                          <img src={DislikeSvg} alt="dislike"></img>
                          <span className="text-gray-400">18</span>
                        </div>
                        <div className="d-flex items-center gap-[2px]">
                          <img src={CommentSvg} alt="comment"></img>
                          <span className="text-gray-400">4</span>
                        </div>
                      </div>
                      <div className="d-flex gap-2 items-center my-1">
                        <img src={MenuSvg} alt="menu"></img>
                        <img src={ForwardSvg} alt="forward"></img>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsImageFlip;
